<script>
    import { createEventDispatcher } from 'svelte'
    import ClientAddressItem from './ClientAddressItem.svelte'

    export let data = []

    const dispatch = createEventDispatcher ();

    const onAddressChange = event => {
        const { index, value } = event.detail
        data[index] = value;
        dispatch ('change', data);
    }

    const onRemove = event => {
        data.splice (event.detail.index, 1);
        dispatch ('change', data)
    }

    const onAdd = event => {
        data.push ({
            "name": "",
            "street": "",
            "city": ""
        });
        dispatch ('change', data)
    }
</script>

<style>
    .Address {
        margin-top: 20px;
    }
    .add-address {
        margin-top: 10px;
        font-weight: 600;
        padding: 0 15px;
        line-height: 28px;
        border-radius: 3px;
        cursor: default;
        display: inline-block;
    }
    .add-address:hover {
        background-color: var(--sidelink-hover);
    }
</style>

<div class="Address">
    <!-- <div class="heading">Indirizzi</div> -->
    {#each data as address, index}
        <ClientAddressItem {index} data={address} on:change={onAddressChange} on:remove={onRemove} />
    {/each}
    <div class="add-address" on:click={onAdd}>Aggiungi Indirizzo</div>
</div>